import React from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { changeCheckedFlights } from "../searchFlightsSlice";
import { generateFlightKey } from "../utils";
import { useTranslation } from "react-i18next";

function FlightCheckbox({ result }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const checked = useAppSelector(
    (state) =>
      state.searchFlights.results.checkedFlights[generateFlightKey(result)]
  );

  const checkFlight = (e) => {
    dispatch(
      changeCheckedFlights({
        key: generateFlightKey(result),
        flight: result,
      })
    );
  };

  return (
    <input
      type="checkbox"
      title={t("CLIPBOARD_FLIGHT_CHECKBOX_TITLE")}
      checked={checked === undefined ? false : checked}
      onChange={checkFlight}
    />
  );
}

export default FlightCheckbox;
